













import { AuthType } from "@/shared/types";
import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import VueRouter from "vue-router";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    GenericLoadingSpinner,
    LoginWrapper
  }
})
export default class OktaEmailVerify extends Vue {
  $router: VueRouter;
  @Prop() emailVerificationCode: string;
  @Prop() signature: string;
  @Prop() routeToHome: string;

  userStore = useUserStore();

  created () {
    this.userStore.setAuthType(AuthType.Okta);
    this.verifyEmail();
  }

  ensureNotLoggedIn () {
    return this.userStore.loggedIn ? this.userStore.logout() : Promise.resolve();
  }

  verifyEmail () {
    this.ensureNotLoggedIn()
        .then(_ => {
          if (this.emailVerificationCode) {
            this.userStore.verifyIdpEmailChange({ verifyLinkId: this.emailVerificationCode, signature: this.signature })
                .finally(() => this.$router.replace(this.routeToHome));
            return;
          }
          this.$router.replace(this.routeToHome);
        });
  }
}
